export default {
    userCourses: [],
    addCourseUser: false,
  };